import { makeStyles, css } from '@conexasaude/conexa-hero'
import { SerializedStyles } from '@emotion/react'
import { scrollbar } from './customScrollbar'

export const globalStylesEmotion = (
  props?: Record<string, string>,
): SerializedStyles => css`
  .chatlayer-chatbox-wrapper {
    z-index: 99999;
    max-height: 590px !important;
    right: unset !important;
    left: 0 !important;
  }

  .chatlayer-chatbox-button {
    align-self: flex-start !important;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }

  @media (max-width: 639px) {
    .chatlayer-chatbox-wrapper {
      width: 100vw !important;
      height: ${props?.height || '100vh'} !important;
      max-height: unset !important;
    }

    .chatlayer-iframe {
      position: absolute !important;
      top: 0px !important;
      left: 0px !important;
      right: 0px !important;
      width: 100vw !important;
      z-index: 999 !important;
    }
  }
`

const globalStyles = makeStyles({
  mainContainer: () => css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    overflow-y: auto;
  `,

  typography: theme => {
    return css`
      div,
      span {
        font-family: ${theme.typography.paragraphLarge.fontFamily}, sans-serif;
      }

      body,
      html {
        font-family: ${theme.typography.paragraphLarge.fontFamily};
        font-size: ${theme.typography.paragraphLarge.fontSize};
        font-weight: ${theme.typography.paragraphLarge.fontWeight};
        line-height: ${theme.typography.paragraphLarge.lineHeight};
        background: white;
      }

      body:fullscreen {
        overflow: auto;
      }
      body:-ms-fullscreen {
        overflow: auto;
      }
      body:-webkit-full-screen {
        overflow: auto;
      }
      body:-moz-full-screen {
        overflow: auto;
      }

      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      ${scrollbar()}
    `
  },
})

export default globalStyles
